function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { getOriginalFunction } from '@sentry/utils';
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */

var FunctionToString = /*#__PURE__*/function () {
  function FunctionToString() {
    _classCallCheck(this, FunctionToString);

    FunctionToString.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */


  _createClass(FunctionToString, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setupOnce",
    value: function setupOnce() {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originalFunctionToString = Function.prototype.toString; // eslint-disable-next-line @typescript-eslint/no-explicit-any

      Function.prototype.toString = function () {
        var context = getOriginalFunction(this) || this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return originalFunctionToString.apply(context, args);
      };
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'FunctionToString';
    }
  }]);

  return FunctionToString;
}();

FunctionToString.__initStatic();

export { FunctionToString };